// Path: ./src/app/components/MuiConfirmationModal/styled.ts
import { Button, ButtonProps, styled } from "@mui/material";

export const CancelButton = styled(Button)<ButtonProps>(() => ({
  color: "black",
  backgroundColor: "white",
  textTransform: "capitalize",
  "&:hover": {
    backgroundColor: "white",
  },
}));

export const ConfirmButton = styled(Button)<
  ButtonProps & { buttonColor?: string }
>(({ buttonColor }) => ({
  color: "white",
  backgroundColor: buttonColor || "red",
  textTransform: "capitalize",
  "&:hover": {
    backgroundColor: buttonColor || "red",
  },
}));
